module.exports = __webpack_public_path__ + "static/img/fission-banner.2e669e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/fission-banner.png
// module id = +ESl
// module chunks = 216